<template>
  <table-column-element
    v-bind="$attrs"
    v-on="$listeners"
    :label="label"
    :width="width"
    :prop="$attrs.prop || 'date'"
    :formatter="dateFormatter"
  >
    <template v-slot="scope">
      {{ dateFormatter(scope.row, scope.column, getNestedValue(scope.row, scope.column.property), scope.$index) }}
    </template>
  </table-column-element>
</template>

<script>
  import filters from '../filters'

  const {formatDate, formatDateFromNow} = filters

  export default {
    props: {
      tableColumnType: { type: String, default: 'date' }, 
      label: {
        type: String,
        default: 'Дата',
      },
      width: {
        // type: Number,
        default: 220,
      },
      fromNow: {
        type: Boolean,
        default: false,
      },
      fromNowRemoveSuffix: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      dateFormatter (row, column, cellValue, index) {
        return cellValue 
          ? (this.fromNow 
              ? formatDateFromNow(cellValue, this.fromNowRemoveSuffix) 
              : formatDate(cellValue))
          : '–';
      },
      getNestedValue(obj, path) {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/table-column-date.vue